import React from 'react';
import { ThreeDots } from 'react-loader-spinner';

const CustomLoader = ({ customstyles = {}, width = 70, height = 70, color = '#607d8b' }) => {
  return (
    <div className="row justify-content-md-center h-100" style={customstyles}>
      <ThreeDots color={color} height={height} width={width} />
    </div>
  );
};

export default CustomLoader;
